"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const keyBy_1 = tslib_1.__importDefault(require("lodash/keyBy"));
const __elasticsearch_1 = require("../../../../__elasticsearch");
const __enums_1 = require("../../../../__types/__enums");
const UserMetricAggregation = {
    totalCount: {
        sum: {
            script: '1'
        }
    },
    certificates: {
        nested: {
            path: 'certificates'
        },
        aggs: {
            certificates: {
                value_count: {
                    field: 'certificates.certificateTemplateId'
                }
            }
        }
    },
    checkpoint: {
        filter: {
            term: {
                contentType: __enums_1.ContentTypeEnum.CHECKPOINT
            }
        },
        aggs: {
            count: {
                sum: {
                    script: '1'
                }
            }
        }
    },
    liveTraining: {
        filter: {
            term: {
                contentType: __enums_1.ContentTypeEnum.ILT
            }
        },
        aggs: {
            count: {
                sum: {
                    script: '1'
                }
            }
        }
    },
    offerTimeSpent: {
        filter: {
            term: {
                contentType: __enums_1.ContentTypeEnum.OFFER
            }
        },
        aggs: {
            timeSpent: {
                sum: {
                    field: 'timeSpent'
                }
            }
        }
    },
    offer: {
        filter: {
            term: {
                contentType: __enums_1.ContentTypeEnum.OFFER
            }
        },
        aggs: {
            count: {
                sum: {
                    script: '1'
                }
            }
        }
    },
    curriculumOfferTimeSpent: {
        filter: {
            term: {
                contentType: __enums_1.ContentTypeEnum.CURRICULUM_OFFER
            }
        },
        aggs: {
            timeSpent: {
                sum: {
                    field: 'timeSpent'
                }
            }
        }
    },
    curriculumOffer: {
        filter: {
            term: {
                contentType: __enums_1.ContentTypeEnum.CURRICULUM_OFFER
            }
        },
        aggs: {
            count: {
                sum: {
                    script: '1'
                }
            }
        }
    },
    complete: {
        filter: {
            term: {
                completionStatus: __enums_1.CompletionStatusValuesEnum.COMPLETED
            }
        },
        aggs: {
            count: {
                sum: {
                    script: '1'
                }
            }
        }
    },
    inProgress: {
        filter: {
            term: {
                completionStatus: __enums_1.CompletionStatusValuesEnum.INCOMPLETE
            }
        },
        aggs: {
            count: {
                sum: {
                    script: '1'
                }
            }
        }
    },
    notStarted: {
        filter: {
            term: {
                completionStatus: __enums_1.CompletionStatusValuesEnum.NOT_ATTEMPTED
            }
        },
        aggs: {
            count: {
                sum: {
                    script: '1'
                }
            }
        }
    },
    overdue: {
        filter: {
            bool: {
                must_not: [
                    {
                        term: {
                            completionStatus: __enums_1.CompletionStatusValuesEnum.COMPLETED
                        }
                    },
                    {
                        term: {
                            'currentEnrolmentInfo.dueDate': -1
                        }
                    }
                ],
                must: [
                    {
                        exists: {
                            field: 'currentEnrolmentInfo.dueDate'
                        }
                    },
                    {
                        range: {
                            'currentEnrolmentInfo.dueDate': {
                                lte: 'now'
                            }
                        }
                    },
                    {
                        terms: {
                            contentType: [__enums_1.ContentTypeEnum.OFFER, __enums_1.ContentTypeEnum.CHECKPOINT, __enums_1.ContentTypeEnum.ILT]
                        }
                    }
                ]
            }
        },
        aggs: {
            count: {
                sum: {
                    script: '1'
                }
            }
        }
    }
};
const getUserMetricsFromBucket = (bucket, prefix) => {
    return {
        [`${prefix}TotalContents`]: bucket ? bucket.totalCount.value : 0,
        [`${prefix}TotalInProgress`]: bucket ? bucket.inProgress.count.value : 0,
        [`${prefix}TotalOverdue`]: bucket ? bucket.overdue.count.value : 0,
        [`${prefix}TotalComplete`]: bucket ? bucket.complete.count.value : 0,
        [`${prefix}TotalCheckpoints`]: bucket ? bucket.checkpoint.count.value : 0,
        [`${prefix}TotalLiveTrainings`]: bucket ? bucket.liveTraining.count.value : 0,
        [`${prefix}TotalCourses`]: bucket ? bucket.offer.count.value : 0,
        [`${prefix}TotalCertificates`]: bucket ? bucket.certificates.certificates.value || 0 : 0,
        [`${prefix}TotalCoursesTimeSpent`]: bucket ? bucket.offerTimeSpent.timeSpent.value : 0,
        [`${prefix}TotalPaths`]: bucket ? bucket.curriculumOffer.count.value : 0,
        [`${prefix}TotalPathsTimeSpent`]: bucket ? bucket.curriculumOfferTimeSpent.timeSpent.value : 0,
        [`${prefix}TotalNotStarted`]: bucket ? bucket.notStarted.count.value : 0
    };
};
const getZeroUserMetrics = (userId) => ({
    userId,
    // direct
    directTotalContents: 0,
    directTotalInProgress: 0,
    directTotalOverdue: 0,
    directTotalComplete: 0,
    directTotalCheckpoints: 0,
    directTotalLiveTrainings: 0,
    directTotalCourses: 0,
    directTotalCoursesTimeSpent: 0,
    directTotalPaths: 0,
    directTotalPathsTimeSpent: 0,
    directTotalNotStarted: 0,
    // inDirect
    inDirectTotalContents: 0,
    inDirectTotalInProgress: 0,
    inDirectTotalOverdue: 0,
    inDirectTotalComplete: 0,
    inDirectTotalCheckpoints: 0,
    inDirectTotalLiveTrainings: 0,
    inDirectTotalCourses: 0,
    inDirectTotalPaths: 0,
    inDirectTotalNotStarted: 0,
    // total
    totalContents: 0,
    totalInProgress: 0,
    totalOverdue: 0,
    totalComplete: 0,
    totalCheckpoints: 0,
    totalLiveTrainings: 0,
    totalCourses: 0,
    totalCoursesTimeSpent: 0,
    totalPaths: 0,
    totalPathsTimeSpent: 0,
    totalTimeSpent: 0,
    totalNotStarted: 0
});
function parseUserMetricElasticsearchResult(users, results) {
    const bucketsByUserId = keyBy_1.default(results.aggregations.counters.buckets, (doc) => doc.key);
    const userMetrics = users.map(user => {
        const userBucket = bucketsByUserId[user.id];
        if (!userBucket) {
            return getZeroUserMetrics(user.id);
        }
        const directBucket = userBucket.direct.buckets.find((bucket) => bucket.key === 1);
        const inDirectBucket = userBucket.direct.buckets.find((bucket) => bucket.key === 0);
        const directDocMetrics = getUserMetricsFromBucket(directBucket, 'direct');
        const inDirectDocMetrics = getUserMetricsFromBucket(inDirectBucket, 'inDirect');
        const { directTotalCoursesTimeSpent, directTotalPathsTimeSpent } = directDocMetrics;
        const { inDirectTotalCoursesTimeSpent } = inDirectDocMetrics;
        delete directDocMetrics.directTotalCoursesTimeSpent;
        delete directDocMetrics.directTotalPathsTimeSpent;
        delete inDirectDocMetrics.inDirectTotalCoursesTimeSpent;
        delete inDirectDocMetrics.inDirectTotalPathsTimeSpent;
        return Object.assign({ userId: userBucket.key }, directDocMetrics, inDirectDocMetrics, { 
            // total
            totalContents: directDocMetrics.directTotalContents + inDirectDocMetrics.inDirectTotalContents, totalInProgress: directDocMetrics.directTotalInProgress + inDirectDocMetrics.inDirectTotalInProgress, totalOverdue: directDocMetrics.directTotalOverdue + inDirectDocMetrics.inDirectTotalOverdue, totalComplete: directDocMetrics.directTotalComplete + inDirectDocMetrics.inDirectTotalComplete, totalCheckpoints: directDocMetrics.directTotalCheckpoints + inDirectDocMetrics.inDirectTotalCheckpoints, totalLiveTrainings: directDocMetrics.directTotalLiveTrainings + inDirectDocMetrics.inDirectTotalLiveTrainings, totalCourses: directDocMetrics.directTotalCourses + inDirectDocMetrics.inDirectTotalCourses, totalCoursesTimeSpent: directTotalCoursesTimeSpent + inDirectTotalCoursesTimeSpent, totalPaths: directDocMetrics.directTotalPaths + inDirectDocMetrics.inDirectTotalPaths, totalPathsTimeSpent: directTotalPathsTimeSpent, totalNotStarted: directDocMetrics.directTotalNotStarted + inDirectDocMetrics.inDirectTotalNotStarted });
    });
    return userMetrics;
}
function getUserMetrics(users) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        if (users.length === 0) {
            return [];
        }
        const userQuery = {
            bool: {
                must: [
                    {
                        term: {
                            deleted: {
                                value: false
                            }
                        }
                    },
                    {
                        terms: {
                            userId: users.map(doc => doc._id || doc.id)
                        }
                    }
                ]
            }
        };
        const metricsQuery = {
            query: userQuery,
            aggs: {
                counters: {
                    terms: {
                        field: 'userId',
                        size: users.length
                    },
                    aggs: {
                        direct: {
                            terms: {
                                field: 'direct',
                                size: 2
                            },
                            aggs: UserMetricAggregation
                        }
                    }
                }
            }
        };
        const elasticsearchClient = yield __elasticsearch_1.getElasticsearchClient(__elasticsearch_1.ElasticsearchURLEnum.ES_AWS_URL);
        const elasticsearchResults = yield elasticsearchClient.search({
            index: __enums_1.ElasticsearchIndicesEnum.STATE,
            type: __enums_1.ElasticsearchTypesEnum.STATE,
            size: 0,
            body: metricsQuery
        });
        return parseUserMetricElasticsearchResult(users, elasticsearchResults);
    });
}
exports.getUserMetrics = getUserMetrics;
//# sourceMappingURL=getUserMetrics.js.map